import { BaseQuery } from './BaseQuery';
import { IExecutionOptions, IQueryAssetOptions } from '../models/query';
import { applySubQueryPlaceholders } from '../utils/applySubQueryPlaceholders';

export class AssetQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		let { key } = this.options;
		const { subQueries, allSubQueryValuesRequired, assetOptions = { source: 'currentAppAsset' } } = this.options;

		key = applySubQueryPlaceholders({
			executionOptions,
			subQueries,
			allSubQueryValuesRequired,
			template: key,
		});

		let baseUrl = '';
		if (executionOptions.serviceUrl) {
			const serviceUrl = executionOptions.serviceUrl;
			baseUrl = serviceUrl.endsWith('/') ? serviceUrl.substr(0, serviceUrl.length - 1) : serviceUrl;
		}
		
		let src = `${baseUrl}/applicationManager/apps`;
		switch (assetOptions.source) {
			case 'ksysAsset':
				src = `${src}/ksys-app-assets/${key}`;
				break;
			case 'appGuidAsset':
				src = `${src}/${(assetOptions as IQueryAssetOptions).applicationGuid}/${key}`;
				break;
			case 'currentAppAsset':
			default:
				src = `${src}/${executionOptions.applicationGuid}/${key}`;
				break;
		}

		return src as any as T;
	}
}